import { FC, PropsWithChildren } from "react";
import { SHEET_CONTENT_VARIANT_CLASS_MAP } from "../Sheet.config";

export const SheetTabbedFormWrapper: FC<PropsWithChildren> = ({ children }) => (
  <div
    data-component="SheetTabbedFormWrapper"
    className={SHEET_CONTENT_VARIANT_CLASS_MAP.boxed}
  >
    { children }
  </div>
);
